module.exports = __webpack_public_path__ + "img/ff20efc.jpg";